import {
  fetchStaffLocationAccessIds,
  isStaffAssignedToLocationViaAccess,
} from "@/lib/locationAccess";
import { fetchStaffExtraJobLocationIds } from "@/lib/extraPaidWork";

export function uniqueLocationIds(
  rows: Array<{ location_id: string | null | undefined }>
): string[] {
  return [
    ...new Set(
      rows
        .map((row) => row.location_id)
        .filter((id): id is string => Boolean(id))
    ),
  ];
}

export async function fetchAssignedLocationIds(staffUserId: string): Promise<string[]> {
  const [accessIds, extraIds] = await Promise.all([
    fetchStaffLocationAccessIds(staffUserId),
    fetchStaffExtraJobLocationIds(staffUserId).catch((error) => {
      console.warn("[fetchAssignedLocationIds] extra jobs", error);
      return [] as string[];
    }),
  ]);
  return [...new Set([...accessIds, ...extraIds])];
}

export async function isStaffAssignedToLocation(
  staffUserId: string,
  locationId: string
): Promise<boolean> {
  return isStaffAssignedToLocationViaAccess(staffUserId, locationId);
}
